module.exports = __webpack_public_path__ + "img/dark-prereqs.3e2b7fd3.png";